import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';
import { Box, MenuItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const AmountToSend = ({ closeAgentDialog, detailViewItem, allCountry }) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('USD');

  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let data = {
      agentId: detailViewItem.userId,
      amount,
      currency,
      transactionType: 'SEND_MONEY',
    };

    try {
      response = await axios({
        url: `/api/v1/private/account/transfer-to-agent`,
        method: 'post',
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // console.log('editForm response', response);

      closeAgentDialog();

      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      // console.log('e', error.response.data.message);
      handleSnakbarOpen(error.response.data.message.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAgentDialog();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          Amount to Send ( {detailViewItem.firstName} {detailViewItem.lastName} )
        </Typography>
      </div>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Amount"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={amount}
          onChange={e => setAmount(e.target.value)}
        />
        <TextField
          variant="outlined"
          select
          label="Currency"
          size="small"
          fullWidth
          required
          value={currency}
          disabled
          // onChange={e => setCurrency(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((e, index) => (
            <MenuItem value={e.currency} key={index}>
              <Box className={classes.inner}>
                <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.currency}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        {/* <TextField
          label="Last Name"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={lastName}
          onChange={e => setLastName(e.target.value)}
        />

        <TextField
          label="Company"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={company}
          onChange={e => setCompany(e.target.value)}
        />

        <TextField
          label="Business Email"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessEmail}
          onChange={e => setBusinessEmail(e.target.value)}
        />

        <TextField
          label="Business Street"
          variant="outlined"
          required
          fullWidth
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessStreet}
          onChange={e => setBusinessStreet(e.target.value)}
        />



        <TextField
          label="Business Phone"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessPhone}
          onChange={e => setBusinessPhone(e.target.value)}
        />

        <TextField
          variant="outlined"
          select
          label="Agent Find Us From"
          size="small"
          fullWidth
          required
          value={agentFindUsFrom}
          onChange={e => setAgentFindUsFrom(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Advertisement">Advertisement</MenuItem>
          <MenuItem value="Social_Media">Social Media</MenuItem>
          <MenuItem value="Word_Of_Mouth">Word Of Mouth</MenuItem>
          <MenuItem value="GlobPay_Sales_Representative">GlobPay Sales Representative</MenuItem>
          <MenuItem value="GlobPay_Website">GlobPay Website</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Type Of Business"
          size="small"
          fullWidth
          required
          value={typeOfBusiness}
          onChange={e => setTypeOfBusiness(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Check_Casher">Check Casher</MenuItem>
          <MenuItem value="Convenience_Store">Convenience Store</MenuItem>
          <MenuItem value="Ethnic_Grocery">Ethnic Grocery</MenuItem>
          <MenuItem value="Grocery">Grocery</MenuItem>
          <MenuItem value="Liquor_Store">Liquor Store</MenuItem>
          <MenuItem value="Multi_Service">Multi Service</MenuItem>
          <MenuItem value="Pharmacy">Pharmacy</MenuItem>
          <MenuItem value="Port">Port</MenuItem>
          <MenuItem value="Biller">Biller</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField> */}

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            Send Money
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default AmountToSend;
